module.exports = __webpack_public_path__ + "img/icon-about-3.c5d1ebc4.png";